import React from "react";

export const Pagination = ({
                               currentPage = 0,
                               totalPages = 0,
                               setCurrentPage,
                               position = "left",
                           }) => {
    if (totalPages <= 1) return null;

    const handlePrev = () => {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages - 1) {
            setCurrentPage(currentPage + 1);
        }
    };

    return (
        <div className={`pagination pagination--${position}`}>
            <button
                className="pagination__btn"
                disabled={currentPage === 0}
                onClick={handlePrev}
            >
                ← Prev
            </button>

            <div className="pagination__pages">
                {Array.from({length: totalPages}).map((_, index) => (
                    <button
                        key={index}
                        className={`pagination__page ${
                            currentPage === index ? "is-active" : ""
                        }`}
                        onClick={() => setCurrentPage(index)}
                    >
                        {index + 1}
                    </button>
                ))}
            </div>

            <button
                className="pagination__btn"
                disabled={currentPage === totalPages - 1}
                onClick={handleNext}
            >
                Next →
            </button>
        </div>
    );
};

export default Pagination;
